import type { Client, Quote, Business } from '@/lib/api';
import { quoteApi } from '@/lib/api';
import { SendDocumentModal, type SendMode } from './SendDocumentModal';

interface SendQuoteModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  quote: Quote;
  client: Client | null;
  business: Business | null;
  mode?: SendMode;
  onSend: (data: {
    medium: 'email' | 'sms';
    to: string[];
    cc: string[];
    bcc: string[];
    subject: string;
    message: string;
    cc_self: boolean;
  }) => Promise<void>;
}

export function SendQuoteModal({
  open,
  onOpenChange,
  quote,
  client,
  business,
  mode = 'send',
  onSend,
}: SendQuoteModalProps) {
  return (
    <SendDocumentModal
      open={open}
      onOpenChange={onOpenChange}
      documentType="quote"
      documentId={quote.id}
      documentNumber={quote.quote_number || quote.id}
      noteForClient={quote.note_for_client}
      client={client}
      business={business}
      mode={mode}
      getSendTemplate={(id, medium) => quoteApi.getSendTemplate(id, medium, mode === 'reminder' ? 'reminder' : undefined)}
      onSend={onSend}
    />
  );
}
